import { notificationConstants } from "../../_constants";

const initialState = {};

//login reducer
export const get_calendar_notification_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case notificationConstants.GET_CALENDAR_NOTIFICATIONS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case notificationConstants.GET_CALENDAR_NOTIFICATIONS_ACTION_SUCCESS:
      return {
        loggedIn: true,
        calendarNotificationData: action.payload,
      };
    case notificationConstants.GET_CALENDAR_NOTIFICATIONS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

//login reducer
export const get_invited_jobs_notification_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case notificationConstants.GET_INVITED_JOBS_NOTIFICATIONS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case notificationConstants.GET_INVITED_JOBS_NOTIFICATIONS_ACTION_SUCCESS:
      return {
        loggedIn: true,
        invitedJobsNotificationData: action.payload,
      };
    case notificationConstants.GET_INVITED_JOBS_NOTIFICATIONS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};

//login reducer
export const get_job_changes_notification_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case notificationConstants.GET_JOB_CHANGES_NOTIFICATIONS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case notificationConstants.GET_JOB_CHANGES_NOTIFICATIONS_ACTION_SUCCESS:
      return {
        loggedIn: true,
        jobChangesNotificationData: action.payload,
      };
    case notificationConstants.GET_JOB_CHANGES_NOTIFICATIONS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        error: action.payload,
      };
    default:
      return state;
  }
};
